import { generateClient } from 'aws-amplify/api';
import { trackInteraction as trackInteractionMutation } from '../graphql/mutations';

class HypeRatingService {
  constructor() {
    this.client = null;
    this.sessionId = this.getOrCreateSessionId();
  }

  async getClient() {
    if (!this.client) {
      this.client = generateClient();
    }
    return this.client;
  }

  getOrCreateSessionId() {
    let sessionId = sessionStorage.getItem('hypeRatingSessionId');
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('hypeRatingSessionId', sessionId);
    }
    return sessionId;
  }

  async trackInteraction(action, movieId, userId, metadata = {}) {
    if (!userId || !movieId) {
      console.log('🎬 HypeRating: Skipping interaction - missing required data', { userId: !!userId, movieId: !!movieId });
      return null;
    }

    const interactionData = {
      userID: userId,
      movieID: movieId,
      contentType: 'MOVIE',
      action,
      sessionID: this.sessionId,
      deviceType: /Mobile|Android|iPhone|iPad/.test(navigator.userAgent) ? 'mobile' : 'desktop',
      platform: 'web',
      metadata: JSON.stringify(metadata),
      isAnonymous: false
    };

    try {
      console.log('🎬 HypeRating: Tracking interaction', { action, movieId, userId });
      console.log('🎬 HypeRating: Interaction data', interactionData);
      
      const client = await this.getClient();
      console.log('🎬 HypeRating: GraphQL client obtained');
      
      const result = await client.graphql({
        query: trackInteractionMutation,
        variables: { input: interactionData }
      });
      
      console.log('🎬 HypeRating: GraphQL result received', result);

      if (result.errors?.length > 0) {
        throw new Error(`GraphQL errors: ${result.errors.map(e => e.message).join(', ')}`);
      }

      console.log('🎬 HypeRating: Interaction tracked successfully', { 
        action, 
        interactionId: result.data?.trackInteraction?.id 
      });

      return result.data?.trackInteraction;
    } catch (error) {
      console.error('🎬 HypeRating: Failed to track interaction', {
        action,
        movieId,
        error: error.message || error.toString() || 'Unknown error',
        errorType: error.constructor.name,
        stack: error.stack,
        interactionData
      });
      
      // Log GraphQL errors in detail
      if (error.errors && error.errors.length > 0) {
        console.error('🎬 HypeRating: GraphQL Errors:', error.errors.map(e => ({
          message: e.message,
          locations: e.locations,
          path: e.path,
          extensions: e.extensions
        })));
      }
      
      if (error.networkError) {
        console.error('🎬 HypeRating: Network Error:', error.networkError);
      }
      
      return null;
    }
  }

  async fetchUpdatedHypeRating(movieId) {
    try {
      const client = await this.getClient();
      const result = await client.graphql({
        query: `
          query GetMovie($id: ID!) {
            getMovie(id: $id) {
              id
              hypeRating
              hypeScore
              totalInteractions
              viewCount
              watchlistCount
              shareCount
              reviewCount
              ottClickCount
            }
          }
        `,
        variables: { id: movieId }
      });

      if (result.errors?.length > 0) {
        console.log('🎬 HypeRating: Movie not found in DynamoDB (expected for new movies)');
        return null;
      }

      return result.data?.getMovie;
    } catch (error) {
      console.log('🎬 HypeRating: Expected error fetching movie data', error.message);
      return null;
    }
  }
}

export default new HypeRatingService();